import { createPortal } from "react-dom";
import { FaWhatsapp } from "react-icons/fa";
import { BriefcaseBusiness } from "lucide-react";
import { useRecruitmentModal } from "../RecruitmentModal/RecruitmentModal";

const TAB_SHELL =
  "group flex w-11 flex-col items-center justify-center gap-2 rounded-l-2xl border border-slate-200/90 bg-white px-1.5 py-3 shadow-[0_6px_22px_rgba(4,30,66,0.14)] transition-all duration-300 hover:-translate-x-1 hover:shadow-[0_10px_28px_rgba(4,30,66,0.2)]";

const TAB_LABEL =
  "[writing-mode:vertical-rl] whitespace-nowrap text-[12px] font-bold leading-none uppercase tracking-[0.08em] text-[#041E42]";

const ICON_CIRCLE =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-full";

function SideTab({ label, iconClassName, icon, onClick, href, ariaLabel }) {
  const body = (
    <>
      <span className={TAB_LABEL}>{label}</span>
      <span className={`${ICON_CIRCLE} ${iconClassName}`} aria-hidden="true">
        {icon}
      </span>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        className={`${TAB_SHELL} cursor-pointer`}
      >
        {body}
      </a>
    );
  }

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className={`${TAB_SHELL} cursor-pointer`}
    >
      {body}
    </button>
  );
}

function FloatingEnquiry() {
  const { openRecruitmentModal } = useRecruitmentModal();

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <aside
      aria-label="Quick actions"
      className="pointer-events-none fixed right-0 top-1/2 z-[10001] flex -translate-y-1/2 flex-col items-end gap-12"
    >
      <div className="pointer-events-auto">
        <SideTab
          label="We're Hiring"
          ariaLabel="We're hiring: send your resume"
          onClick={() => openRecruitmentModal()}
          iconClassName="border border-red-200 bg-white"
          icon={
            <BriefcaseBusiness
              size={19}
              strokeWidth={2.25}
              className="text-red-500"
              aria-hidden="true"
            />
          }
        />
      </div>

      <div className="pointer-events-auto">
        <SideTab
          label="Enquiry"
          ariaLabel="Enquiry on WhatsApp"
          href="https://wa.me/971526013353"
          iconClassName="bg-[#25D366] text-white shadow-sm"
          icon={<FaWhatsapp size={19} aria-hidden="true" />}
        />
      </div>
    </aside>,
    document.body,
  );
}

export default FloatingEnquiry;
